import { Model } from '@/models/Model'
import Property from '@/decorators/Property'
import { ToOneRelation } from 'coloquent/dist/relation/ToOneRelation'
import { RoutePlanner } from '@/models/RoutePlanner'
import { Cargo } from '@/models/Cargo'
import { Vessel } from '@/models/Vessel'
import { ToManyRelation } from 'coloquent/dist/relation/ToManyRelation'
import { Transport } from '@/models/Transport'
import { Company } from '@/models/Company'

export class TrackTraceHash extends Model {
	protected jsonApiType: string = 'trackTraceHashes'

	@Property()
	public emailAddresses!: string

	@Property()
	public comment!: string

	@Property()
	public trackTraceHash!: string

	private route(): ToOneRelation {
		return this.hasOne(RoutePlanner, 'route')
	}

	private vessel(): ToOneRelation {
		return this.hasOne(Vessel, 'vessel')
	}

	public getVessel(): Vessel {
		return this.getRelation('vessel')
	}

	private cargo(): ToOneRelation {
		return this.hasOne(Cargo, 'cargo')
	}

	public getCargo(): Cargo {
		return this.getRelation('cargo')
	}

	private transport(): ToOneRelation {
		return this.hasOne(Transport, 'transport')
	}

	public getTransport(): Transport | null {
		return this.getRelation('transport')
	}

	private activeTrackTraces(): ToManyRelation {
		return this.hasMany(TrackTraceHash, 'activeTrackTraces')
	}

	public getActiveTrackTraces(): Array<TrackTraceHash> {
		return this.getRelation('activeTrackTraces') || []
	}

	public company(): ToOneRelation {
		return this.hasOne(Company, 'company')
	}
}
